window.CareerPortalAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    /**
     * Get enterprise brand children details
     *
     * @param enterpriseId
     * @param limit
     * @param offset
     * @returns {deferred.promise|{then, always}}
     */
    self.getEnterpriseChildren = function (enterpriseId, onlyNames, limit, offset) {
        var deferred = $q.defer();

        var params = {
            only_names: onlyNames,
            limit: limit,
            offset: offset
        }

        _protected.request('enterprise_brand_children_details/' + enterpriseId, 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (res) {
                deferred.reject(res);
            });

        return deferred.promise;
    }

    //Get active positions and categories for brand
    self.getEnterpriseActiveCategoryPositions = function (enterpriseId) {
        var deferred = $q.defer();

        _protected.request('enterprise_active_category_positions/' + enterpriseId, 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (res) {
                deferred.reject(res);
            });

        return deferred.promise;
    };

    self.getBrandPositions = function (brandId) {
        var deferred = $q.defer();

        _protected.request('career_portal/brands/' + brandId + '/positions', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200 && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (res) {
                deferred.reject(res);
            });

        return deferred.promise;
    }

    self.getBrandBasicInfo = function (brandId) {
        var deferred = $q.defer();

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'career_portal/brands/' + brandId + '/basic_info', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.status_code == 200 && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (res) {
                deferred.reject(res);
            });

        return deferred.promise;
    }
    //Get sub brands for brand
    self.getBrandChildrenDetails = function (brandId, isPrivatePortal) {
        var deferred = $q.defer();

        var params = {};

        if (isPrivatePortal) {
            params['career_portal_type'] = 'PRIVATE';
        }

        _protected.request('career_portal/brands/' + brandId + '/tree', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (res) {
                deferred.reject(res);
            });

        return deferred.promise;
    };

    //Get jobs for brand and its subBrands
    self.searchJobsForBrand = function (body) {
        var deferred = $q.defer();

        var requestSignature = JSON.stringify(body);

        _protected.request('harri_search/search_jobs', 'POST', body)
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve({data: res.data.data, requestSignutre: requestSignature});
                } else {
                    deferred.reject(res);
                }
            }, function (res) {
                deferred.reject(res);
            });

        return deferred.promise;
    };

    // API return same data as (harri_search/search_jobs) without pagination with limit 10000
    self.searchJobsForMap = function (body) {
        var deferred = $q.defer();

        var requestSignature = JSON.stringify(body);

        _protected.request('brands/jobs/locations/search', 'POST', body)
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    deferred.resolve({data: res.data.data, requestSignutre: requestSignature});
                } else {
                    deferred.reject(res);
                }
            }, function (res) {
                deferred.reject(res);
            });

        return deferred.promise;
    };

});
